export const isNetworkError = (value: any): boolean => {
  return (
    typeof value === 'object' && value.toString() === 'Error: Network Error'
  );
};
